import { render, staticRenderFns } from "./SendTranscript.vue?vue&type=template&id=73b386af"
import script from "./SendTranscript.vue?vue&type=script&lang=js"
export * from "./SendTranscript.vue?vue&type=script&lang=js"
import style0 from "./SendTranscript.vue?vue&type=style&index=0&id=73b386af&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports